import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoFooter from "../../assets/logo.png";
import { getFirestore } from "../../config/firebase";
import { buildUtmQueryString } from "../../config/whatsappConfig";

const FOOTER_PHONE = "0810-444-1111";
const FOOTER_PHONE_TEL = "08104441111";

const FOOTER_SUCURSALES = [
  {
    nombre: "Montironi Peugeot (SAN FRANCISCO)",
    direccion: "Av. Urquiza 381, San Francisco, Córdoba",
  },
  {
    nombre: "Montironi Peugeot (RAFAELA)",
    direccion: "Av. Sarmiento 154, Rafaela, Santa Fé",
  },
];

const ICON_TELEFONO = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: "middle" }}
  >
    <path
      d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"
      fill="#fff"
    />
  </svg>
);

const Footer = ({ bg }) => {
  const utms = buildUtmQueryString();

  /* sessionStorage.setItem('saludo', 'Bienvenidos a sessionStorage');
  valor = sessionStorage.getItem('saludo');
  */

  const [redesSociales, setRedesSociales] = useState([]);

  useEffect(() => {
    const cargarDatos = async () => {
      const cacheKey = "redesSociales-peugeot";
      const datosLocales = sessionStorage.getItem(cacheKey);

      if (datosLocales && datosLocales !== "undefined") {
        try {
          const parsed = JSON.parse(datosLocales);
          if (parsed?.redes) {
            setRedesSociales(parsed);
            return;
          }
          sessionStorage.removeItem(cacheKey);
        } catch (error) {
          sessionStorage.removeItem(cacheKey);
        }
      }

      const db = getFirestore();
      try {
        const snap = await db.collection("peugeot-informacion").doc("redes-sociales").get();
        if (snap.exists) {
          const info = { id: snap.id, ...snap.data() };
          setRedesSociales(info);
          sessionStorage.setItem(cacheKey, JSON.stringify(info));
        }
      } catch (error) {
        console.log(error);
      }
    };

    cargarDatos();
  }, []);

  return (
    <>
      <Container fluid className="footer mt-4">
        <Container>
          <Row className="align-items-center">
            <Col
              xs={12}
              md={3}
              className="text-sm-start text-center pt-3 d-flex align-items-center columnas-foots-centrar-mobile"
            >
              <Link to={`/${utms}`}>
                <img src={logoFooter} alt="Montironi Peugeot" className="img-fluid" />
              </Link>
            </Col>
            <Col xs={12} md={6} className="mb-3 mb-md-0 text-start text-md-center pt-md-0 pt-3">
              <span style={{ fontWeight: 300, fontFamily: "inherit", color: "#fff" }}>Teléfono: </span>
              <span style={{ margin: "0 8px", verticalAlign: "middle" }}>{ICON_TELEFONO}</span>
              <a
                href={`tel:${FOOTER_PHONE_TEL}`}
                style={{ color: "#fff", textDecoration: "underline", fontFamily: "inherit" }}
              >
                {FOOTER_PHONE}
              </a>
            </Col>
            <Col
              xs={12}
              md={3}
              className="pt-3 social d-flex align-items-center justify-content-md-end columna-seguinos-en"
            >
              <p>Seguinos en:</p>
              <div>
                {redesSociales.redes &&
                  redesSociales.redes.map((red) => {
                    return red.disponible ? (
                      <a href={red.url} target="_blank" rel="noreferrer" className="px-2" key={red.url}>
                        <img src={red.url_icon} alt="Logo" />
                      </a>
                    ) : null;
                  })}
              </div>
            </Col>
          </Row>
          <Row className="footer-encontranos">
            <Col xs={12} className="pt-4 text-center text-md-start">
              <p className="footer-encontranos__titulo">ENCONTRANOS EN:</p>
              <div className="footer-encontranos__sucursales">
                {FOOTER_SUCURSALES.map((sucursal) => (
                  <div className="footer-encontranos__sucursal" key={sucursal.nombre}>
                    <p className="footer-encontranos__nombre">{sucursal.nombre}</p>
                    <p className="footer-encontranos__direccion">{sucursal.direccion}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="pt-3 ocultar-mobile-legal">
              <p className="legal">
                El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                parcial o total sin previo aviso.
              </p>
            </Col>
            <Col xs={12} className="pt-3 mostrar-mobile-legal">
              <p className="legal">
                El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                parcial o total sin previo aviso.
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="copyright">
        <Container>
          <Row>
            <Col md={12} xs={12} className="text-center">
              <p>
                Copyright © {new Date().getFullYear()} Montironi Peugeot - Todos los derechos reservados - Políticas de
                Seguridad
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default Footer;
